import React, { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import axios from "axios";
import config from '../../config';
import './DashBoardSetting.css'

const DashBoardSetting = () => {
  const settingList = useSelector((state) => state.settingList || {});
  // ✅ 리덕스 실시간 카운트만 사용
  const dashboardData = useSelector((state) => state.dashboardData || {});
  console.log("dashboardData", dashboardData);
  

  const [dashboardName, setDashboardName] = useState("현황판1");
  const [dashboardProtocol, setDashboardProtocol] = useState("MRTV-1");
  const [deviceId, setDeviceId] = useState("254");
  const [inputcommPort, setcommPort] = useState('RS485-CH1');
  const [ipAddress, setIpAddress] = useState("192.168.105.101");
  const [ipPort, setIpPort] = useState("502");
  const [sendInterval, setSendInterval] = useState("30");
  const [electricFee, setElectricFee] = useState("");
  const [noticeMessage, setNoticeMessage] = useState("");
  const [dashboardList, setDashboardList] = useState([]);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editItem, setEditItem] = useState(null);

  const { commPortList = [], Dashboard_protocollist = [] } = settingList;

  const handleSaveAll = async () => {
    const interval = parseInt(sendInterval);
    if (isNaN(interval) || interval < 10) {
      alert("전송간격은 최소 10초 이상이어야 합니다.");
      return;
    }

    const byteLength = new TextEncoder("euc-kr").encode(noticeMessage).length;
    if (byteLength > 106) {
      alert(`안내 메시지는 106바이트 이내여야 합니다. 현재: ${byteLength}바이트`);
      return;
    }

    try {
      const payload = {
        Dashboard_address: deviceId,
        Dashboard_name: dashboardName,
        Dashboard_protocol: dashboardProtocol,
        commPort: inputcommPort,
        send_interval: parseInt(sendInterval),
        electric_fee: parseFloat(electricFee),
        notice_message: noticeMessage,
      };

      if (inputcommPort === 'ETHERNET') {
        payload.Dashboard_ethernetip = ipAddress;
        payload.Dashboard_ethernetport = parseInt(ipPort);
      }

      await axios.post(`${config.backendUrl}/api/save-dashboard`, payload);
      alert("현황판 설정이 저장되었습니다.");
      fetchDashboardSettings();
    } catch (err) {
      console.error("저장 실패:", err);
      alert("저장 중 오류가 발생했습니다.");
    }
  };

  const fetchDashboardSettings = async () => {
    try {
      const response = await axios.get(`${config.backendUrl}/api/get-dashboard`);
    const data = response.data;

      if (Array.isArray(data)) {
        setDashboardList(data);
      } else {
        setDashboardList([data]);
      }
      // console.log("DashboardList", dashboardList);
    } catch (err) {
      console.error("설정 불러오기 실패:", err);
    }
  };

  useEffect(() => {
    fetchDashboardSettings();
  }, []);

  const handleEdit = (item) => {
    setEditItem({ ...item });
    setShowEditModal(true);
  };

  const handleUpdate = async () => {
    if (!editItem) return;

    try {
      await axios.put(`${config.backendUrl}/api/update_dashboard/${editItem.seq}`, editItem);
      alert("수정되었습니다.");
      setShowEditModal(false);
      fetchDashboardSettings();
    } catch (err) {
      console.error("수정 실패:", err);
      alert("수정 중 오류가 발생했습니다.");
    }
  };

  const handleDelete = async (seq) => {
    if (!window.confirm("이 현황판을 삭제하시겠습니까?")) return;

    try {
      await axios.delete(`${config.backendUrl}/api/delete-dashboard/${seq}`);
      alert("삭제되었습니다.");
      fetchDashboardSettings();
    } catch (err) {
      console.error("삭제 실패:", err);
      alert("삭제 중 오류가 발생했습니다.");
    }
  };

  // seq → index 매핑 생성
  // memo로 최적화(선택)
  const seqIndexMap = useMemo(() => {
    const map = {};
    (dashboardData.seq || []).forEach((s, i) => { map[Number(s)] = i; });
    return map;
  }, [dashboardData.seq]);


  console.log("dashboardData", dashboardData);

  return (
    <>
      <div className="dashboard-wrapper">
        <div className="dashboard-header">
          <div className="dashboard-setting-item">
            <label className="setting-label">현황판 이름</label>
            <input
              type="text"
              className="input-field"
              placeholder="예: Main Dashboard"
              value={dashboardName}
              onChange={(e) => setDashboardName(e.target.value)}
            />
          </div>

          <div className="dashboard-setting-item">
            <label className="setting-label">장비 ID</label>
            <input
              type="text"
              className="input-field"
              placeholder="예: FA"
              value={deviceId}
              onChange={(e) => setDeviceId(e.target.value)}
            />
          </div>

          <div className="dashboard-setting-item">
            <label className="setting-label">프로토콜 선택</label>
            <select
              className="input-field text-center"
              value={dashboardProtocol}
              onChange={(e) => setDashboardProtocol(e.target.value)}
            >
              {Dashboard_protocollist.map((protocol, index) => (
                <option key={index} value={protocol}>
                  {protocol}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="dashboard-settings">
          <div className="form-group">
            <label htmlFor="commPortSelect">통신 포트</label>
            <select
              id="commPortSelect"
              className="form-control"
              value={inputcommPort}
              onChange={(e) => setcommPort(e.target.value)}
            >
              {commPortList.map((port, index) => (
                <option key={index} value={port}>
                  {port}
                </option>
              ))}
            </select>
          </div>

          {inputcommPort === 'ETHERNET' && (
            <>
              <div className="dashboard-setting-item">
                <label className="setting-label">IP 주소</label>
                <input
                  type="text"
                  className="input-field"
                  placeholder="예: 192.168.0.100"
                  value={ipAddress}
                  onChange={(e) => setIpAddress(e.target.value)}
                />
              </div>

              <div className="dashboard-setting-item">
                <label className="setting-label">포트 번호</label>
                <input
                  type="text"
                  className="input-field"
                  placeholder="예: 502"
                  value={ipPort}
                  onChange={(e) => setIpPort(e.target.value)}
                />
              </div>
            </>
          )}

          <div className="dashboard-setting-item">
            <label className="setting-label">전송간격 설정(초)</label>
            <input
              type="number"
              className="input-field"
              min="10"
              placeholder="예: 10"
              value={sendInterval}
              onChange={(e) => setSendInterval(e.target.value)}
            />
          </div>

          <div className="dashboard-setting-item">
            <label className="setting-label">전기 요금 (원/kWh)</label>
            <input
              type="text"
              className="input-field"
              placeholder="예: 125"
              value={electricFee}
              onChange={(e) => setElectricFee(e.target.value)}
            />
          </div>

          <div className="dashboard-setting-item">
            <label className="setting-label">안내 메시지</label>
            <input
              type="text"
              className="input-field"
              placeholder="예: 유지보수 점검 중입니다"
              value={noticeMessage}
              onChange={(e) => setNoticeMessage(e.target.value)}
            />
          </div>
        </div>

        <div className="dashboard-footer">
          <button className="save-btn" onClick={handleSaveAll}>
            현황판 저장하기
          </button>
        </div>

        <div className="dashboard-table">
          <h4>등록된 현황판 목록</h4>
          <table className="custom-table">
            <thead>
              <tr>
                <th>이름</th>
                <th>프로토콜</th>
                <th>장비 ID</th>
                <th>통신 포트</th>
                <th>IP</th>
                <th>PORT</th>
                <th>전송간격</th>
                <th>요금</th>
                <th>안내 메시지</th>
                <th>송신</th>
                <th>수신</th> 
                <th>수정</th>
                <th>삭제</th>
              </tr>
            </thead>
            <tbody>
              {dashboardList.map((item, index) => {
                const idx = seqIndexMap[Number(item.seq)];   // ← 등록된 현황판의 seq로 인덱스 찾기
                const send = (idx !== undefined && idx !== -1) ? dashboardData.sendCount?.[idx] : '-';
                const recv = (idx !== undefined && idx !== -1) ? dashboardData.receiveCount?.[idx] : '-';
                
                return (
                  <tr key={index}>
                    <td>{item.Dashboard_name}</td>
                    <td>{item.Dashboard_protocol}</td>
                    <td>{item.Dashboard_address}</td>
                    <td>{item.Dashboard_comport}</td>
                    <td>{item.Dashboard_ethernetip || '-'}</td>
                    <td>{item.Dashboard_ethernetport || '-'}</td>
                    <td>{item.send_interval}</td>
                    <td>{item.electric_fee}</td>
                    <td>{item.notice_message}</td>
                    <td>{send}</td> 
                    <td>{recv}</td>    
                    <td>
                      <button className="edit-btn" onClick={() => handleEdit(item)}>수정</button>
                    </td>
                    <td>
                      <button className="delete-btn" onClick={() => handleDelete(item.seq)}>삭제</button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      {showEditModal && editItem && (
        <div className="custom-modal-overlay">
          <div className="custom-modal-container">
            <h5 className="custom-modal-title">현황판 수정</h5>
            <div className="custom-modal-content">
              <label>이름</label>
              <input
                className="custom-input"
                value={editItem.Dashboard_name}
                onChange={(e) => setEditItem({ ...editItem, Dashboard_name: e.target.value })}
              />
              <label>전송간격 (초)</label>
              <input
                className="custom-input"
                type="number"
                value={editItem.send_interval}
                onChange={(e) => setEditItem({ ...editItem, send_interval: e.target.value })}
              />
              <label>요금</label>
              <input
                className="custom-input"
                value={editItem.electric_fee}
                onChange={(e) => setEditItem({ ...editItem, electric_fee: e.target.value })}
              />
              <label>안내 메시지</label>
              <input
                className="custom-input"
                value={editItem.notice_message}
                onChange={(e) => setEditItem({ ...editItem, notice_message: e.target.value })}
              />
            </div>
            <div className="custom-modal-actions">
              <button onClick={() => setShowEditModal(false)} className="custom-btn cancel">닫기</button>
              <button onClick={handleUpdate} className="custom-btn confirm">저장</button>
            </div>
          </div>
        </div>
      )}

    </>
  );
};

export default DashBoardSetting;
